module.exports = __webpack_public_path__ + "static/media/call-now.d56d7578.svg";